import React, { Component } from 'react'
import axios from 'axios'
import authservice from '../../Authentication/service/authservice';
import 'antd/dist/antd.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { Link } from "react-router-dom";
import StarRatingComponent from 'react-star-rating-component';
import defaultUserProfile from '../../../assets/defaultUserProfile.png'
import { AnimatedText } from '../../AnimatedText';
import { notifyUser, type } from '../../utility/notifyUser';
import Loader from '../../utility/Loader';
import dateFormator from '../../utility/dateFormator';
import { ButtonStyle } from '../../UIElements/Buttons/ButtonStyle';
import styles from '../forms/addpost.module.css'

class ReviewsAndComments extends Component {

    state = {
        reviews: [],
        averageRating: 0,
        comments: [],
        currentUserReview: null,
        currentUser: {},
        rating: 0,
        showCommentForm: false,
        editReview: false,
        editComment: false,
        review: '',
        comment: '',
        errors: {
            reviews: '',
            comment: ''
        }
    }

    componentDidMount() {
        this.setState({ currentUser: authservice.getCurrentUser() })
        this.getReviews()
    }

    getReviews = () => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/abmgr/reviews/get-reviews/${this.props.listing.hpId}`).then(response => {
            this.setUpReviewsData(response.data);
            console.log(response.data)
        }).catch(error => {
            const errors = this.state.errors;
            errors.reviews = 'Unable to Load Comments';
            this.setState({ errors })
        })
    }

    setUpReviewsData = (data) => {
        if (!data.reviews)
            data.reviews = [];
        const noOfReviews = data.reviews.length

        if (this.state.currentUser && data.reviews) {
            const index = data.reviews.findIndex(r => {
                return r.user.id === this.state.currentUser.id;
            })
            if (index > -1) {
                const currentUserReview = data.reviews.splice(index, 1)[0]
                this.setState({ currentUserReview: currentUserReview, rating: currentUserReview.rating, review: currentUserReview.description, editReview: false })
            } else {
                this.setState({ editReview: true })
            }
        }
        this.props.setReviewsGlance({
            averageRating: data.averageRating,
            totalReviews: (noOfReviews === 0) ? 'No Comments' : `${noOfReviews} Comments`
        });
        this.setState({ reviews: data.reviews, averageRating: data.averageRating });
    }

    getComments = (reviewId) => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/abmgr/reviews/get-comments/${reviewId}`).then(response => {
            console.log(response.data)
        }).catch(error => {
            const errors = this.state.errors;
            errors.reviews = 'Unable to Load Comments';
            this.setState({ errors })
        })
    }

    onStarClick(nextValue, prevValue, name) {
        //console.log('name: %s, nextValue: %s, prevValue: %s', name, nextValue, prevValue);
        this.setState({ rating: nextValue });
    }

    _getCommentsTitle(commentCount) {
        return (commentCount === 0) ? 'No comments yet' : `${commentCount} comments`;
    }

    submitReview = () => {
        if (this.state.rating) {
            this.setState({ posting: true });
            const review = {
                rating: this.state.rating,
                text: this.state.review,
                listingId: this.props.listing.hpId,
                userId: this.state.currentUser.id,
                reviewId: this.state.currentUserReview ? this.state.currentUserReview.reviewId : null,
            }
            if (this.state.review.trim().length < 100) {
                const errors = this.state.errors;
                errors.review = "Comment should be minimum of 100 characters."
                this.setState({ errors })
                this.setState({ posting: false });
                return notifyUser("Comment", "Comment should be minimum of 100 characters.", "warning");
            } else {
                axios.post(`${process.env.REACT_APP_BACKEND_URL}/abmgr/reviews/post-review`, review)
                    .then(response => {
                        this.setUpReviewsData(response.data);
                        this.setState({ posting: false })
                        notifyUser("Comment & Rating", "Your Comment is Submited Successfully!", "success");
                    }).catch(error => {
                        this.setState({ posting: false });
                        notifyUser("Review & Rating", error.response.data, "danger");
                        console.log(error)
                    })
            }
        } else {
            notifyUser("Rating", "Please Give Rating ", "warning");
        }
    }

    _likeDislike(vote, review, index) {
        if (this.props.isAdmin)
            return
        if (this.state.currentUser && this.state.currentUser.id) {
            if ((vote === 'liked' && review.likes.includes(this.state.currentUser.id)) || (vote === 'disliked' && review.disLikes.includes(this.state.currentUser.id)))
                vote = ''

            axios.get(`${process.env.REACT_APP_BACKEND_URL}/abmgr/reviews/vote/${review.reviewId}`, {
                params: {
                    vote: vote,
                    userId: this.state.currentUser.id
                }
            }).then(response => {
                review.likes = response.data.likes
                review.disLikes = response.data.disLikes
                const reviews = this.state.reviews;
                reviews[index] = review
                this.setState({ reviews })
            }).catch(error => {
                console.log(error.response)
                if (error.response)
                    notifyUser("Vote", "Somthing is not right!", "warning");
            })
        } else {
            notifyUser("Vote", "Please login..to Vote!", "warning");
        }
    }

    _addComment = () => {
        if (this.state.comment.trim().length === 0) {
            const errors = this.state.errors;
            errors.comment = "Comment can not be empty"
            this.setState({ errors })
        }
        if (this.state.comment.trim().length < 100) {
            const errors = this.state.errors;
            errors.comment = "Comment should be minimum of 100 characters"
            this.setState({ errors })
            return;
        }
        this.setState({ postingComment: true })
        const comment = {
            text: this.state.comment,
            userId: this.state.currentUser.id,
            parentReview: this.state.review_id,
            reviewId: this.state.commentId,
            replyTo: this.state.replyingTo ? this.state.replyingTo.reviewId : null,
        }
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/abmgr/reviews/post-review`, comment)
            .then(response => {
                this.setState({
                    comments: response.data,
                    showComments: true, showCommentForm: false, editComment: false,
                    comment: '', editForm: false, postingComment: false,
                });
                notifyUser("Comment", "Successfully submitted your comment! ", "success");

                const { reviews } = this.state
                for (let index = 0; index < reviews.length; index++) {
                    const review = reviews[index];
                    if (review.reviewId === this.state.review_id) {
                        review.numberOfComments = response.data.length
                        reviews[index] = review;
                        this.setState({ reviews })
                        break;
                    }
                }
            }).catch(error => {
                this.setState({ postingComment: false });
                notifyUser("Comment", error.response.data, "danger");
            })
    }

    showComments = (reviewId) => {
        if (this.state.review_id !== reviewId)
            //if comments is opened for different review then hide comment form if it opend some place else
            this.setState({ showCommentForm: false })

        axios.get(`${process.env.REACT_APP_BACKEND_URL}/abmgr/reviews/get-comments/${reviewId}`).then(response => {
            this.setState({
                comments: response.data, showComments: true,
                review_id: reviewId,
            })
        }).catch(error => {
            const errors = this.state.errors;
            errors.reviews = 'Unable to Load Comments';
            this.setState({ errors })
        })
    }

    handleCommentInput = (e) => {
        const comment = e.target.value;
        this.setState({ comment: comment })
        let errors = { ...this.state.errors }
        if (comment.trim() >= 100) {
            errors.comment = ""
        } else
            errors.comment = 'Too short comment, Please use minimum 100 characters'
        this.setState({ errors })
    }

    //Form Handlers
    _editReview = () => {
        this.setState({
            editReview: !this.state.editReview,
            showCommentForm: false,
            showComments: false,
            editComment: false,
            review_id: this.state.currentUserReview.reviewId,
        })
    }

    openCommentsForm = (reviewid) => {
        this.setState({
            comment: '',
            showComments: this.state.review_id === reviewid, //if comment form is opened for different review then hide all comments currently beign shown 
            review_id: reviewid,
            showCommentForm: true,
            editComment: false,
            //editReview: false,
            replyingTo: null,
        });

        if (this.state.review_id !== reviewid && this.state.errors.comment.length > 0) {
            const errors = this.state.errors;
            errors.comment = ""
            this.setState({ errors })
        }
    }

    _editComment(comment) {
        const repliedTo = comment.repliedTo ? {
            reviewId: comment.repliedTo,
            description: this.findTagedComment(comment.repliedTo, 290)
        } : null
        this.setState({
            comment: comment.description,
            showCommentForm: true,
            editComment: true,
            //editReview: false,
            commentId: comment.reviewId,
            replyingTo: repliedTo,
        })
    }
    //END Form Handler

    findTagedComment = (commentId, limit) => {
        let taggedComment;
        this.state.comments.some(e => {
            if (e.reviewId === commentId)
                taggedComment = e.description
            return e.reviewId === commentId
        })
        return taggedComment //this.add3Dots(taggedComment, limit);
    }

    add3Dots = (text, limit) => {
        if (text && text.length > limit)
            text = text.substring(0, limit) + '...';
        return text;
    }

    replyToComment = (comment) => {
        this.openCommentsForm(this.state.review_id)
        this.setState({ replyingTo: comment })
    }

    focusComment = (elementId) => {
        if (elementId !== '') {
            const focused = document.getElementsByClassName('flash_content')
            if (focused.length)
                focused.item(0).classList.remove('flash_content')
            const el = document.getElementById(elementId);
            if (el) {
                let h = window.pageYOffset + el.getBoundingClientRect().top - 400
                window.scrollTo({ top: h, behavior: "smooth" })
                el.classList.add('flash_content')
            }
        }
    }

    deleteReview = (reviewId, index) => {
        axios.delete(process.env.REACT_APP_BACKEND_URL + `/abmgr/reviews/delete-review/${reviewId}`)
            .then(response => {
                if (response.data) {
                    notifyUser('Delete Comment', 'The comment has been deleted', type.SUCCESS);
                    // Update the state to remove the deleted review
                    const updatedReviews = [...this.state.reviews];
                    updatedReviews.splice(index, 1);
                    this.setState({ reviews: updatedReviews });
                }
            })
            .catch(error => {
                alert(error);
                Loader.stopSpinner();
            });
    };

    deleteComment = (reviewId, index) => {
        axios.delete(process.env.REACT_APP_BACKEND_URL + `/abmgr/reviews/delete-review/${reviewId}`)
            .then(response => {
                if (response.data) {
                    notifyUser('Delete Comment', 'The comment has been deleted', type.SUCCESS);
                    // Update the state to remove the deleted review
                    const updatedComments = [...this.state.comments];
                    updatedComments.splice(index, 1);
                    this.setState({ comments: updatedComments });
                }
            })
            .catch(error => {
                alert(error);
                Loader.stopSpinner();
            });
    };

    renderComments = () => {
        return (
            <div className="row form-row">
                <div className="comment-form-actions  col-md-12">{
                    this.state.comments.map((comment) => {
                        return (
                            <div key={comment.reviewId}>{(this.state.currentUser && comment.user.id === this.state.currentUser.id) && this.state.editComment ? null :
                                <div>
                                    {comment.repliedTo ? <div className="taged_comment" onClick={() => this.focusComment(comment.repliedTo)} >{this.findTagedComment(comment.repliedTo, 160)}</div> : null}
                                    <div key={comment.reviewId} id={comment.reviewId} className="comment">
                                        <img className='avatar-shape-reply avatar-shape' src={comment.user.profilePhoto ? process.env.REACT_APP_IMAGES_URL + comment.user.profilePhoto : defaultUserProfile} alt="" />
                                        <div className="reply">
                                            <div className='basic_time_div'>
                                                <h6 className="comment-header">{this.props.isAdmin ? comment.user.userName : `${comment.user.firstName} ${comment.user.lastName}`} &middot; <span> {dateFormator.timeAgo(comment.postedDateTime)}</span>
                                                </h6>
                                                {this.props.isAdmin ? <button key={comment.reviewId} id={comment.reviewId} type='button' className="btn btn-danger" onClick={() => this.deleteComment(comment.reviewId)}><i className="fa fa-trash-o" aria-hidden="true"></i></button> : null}
                                                {this.state.currentUser && comment.user.id === this.state.currentUser.id && comment.open ?
                                                    <div className="comment-footer">
                                                        <button className="btn btn-link button_space comment-footer-delete"
                                                            onClick={() => this._editComment(comment)}
                                                        >Edit </button>
                                                    </div> : this.props.isAdmin ? null
                                                        : <div className={`comment-footer ${styles.cursor_rating}`} onClick={() => this.replyToComment(comment)}>
                                                            <i className="fa fa-reply" aria-hidden="true"></i>&nbsp;reply</div>}
                                            </div>

                                            <div className="comment-body">{comment.description}</div>
                                        </div>
                                    </div>
                                </div>}
                            </div>
                        );
                    })}
                </div>
            </div>
        )
    }

    render() {
        const user = this.state.currentUser;

        const commentForm = <div className="row form-row review_text">
            <div className="col-md-12">
                {user && user.id ?
                    <div className="form-group">
                        {this.state.replyingTo ?
                            <div className={`taged_comment ${styles.rating_comment}`}>
                                {this.state.replyingTo.description}</div> : null}
                        <textarea className="form-control input-lg listing_desc" placeholder="Comment"
                            value={this.state.comment} required
                            onChange={this.handleCommentInput}></textarea>
                        <span className="error">{this.state.errors.comment}</span>
                    </div> :
                    <div><Link to='/login/user' >- Please Login -</Link></div>
                }
            </div>
            {user && user.id ?
                <div className="comment-form-actions col-md-12">
                    {this.state.postingComment ? <AnimatedText className={styles.animated_text} text={'3_bars'} /> : <button className="btn btn-info" type="button"
                        onClick={this._addComment}>{this.state.showCommentForm && this.state.editComment ? 'Update Comment' : 'Post Comment'}</button>}<span className="error">{this.state.errors.reviews}</span>
                </div> : null}
        </div>

        const reviews = this.state.reviews.map((review, index) => {
            const userId = user ? user.id : ''
            return (review.description) ?
                <div key={index} className="review_box">
                    <div className="thumbnail small_thumbnail right-caption span4">
                        {this.props.isAdmin ? <div className='text-right'><button key={index} id={`deleteButton-${index}`} type='button' className="btn btn-danger" onClick={() => this.deleteReview(review.reviewId, index)}><i className="fa fa-trash-o" aria-hidden="true"></i></button></div> : null}
                        <img className='avatar-shape' src={review.user.profilePhoto ? process.env.REACT_APP_IMAGES_URL + review.user.profilePhoto : defaultUserProfile} alt="" />
                        <div className="caption">
                            {review.user !== null ? <h6> {this.props.isAdmin ? review.user.userName : `${review.user.firstName} ${review.user.lastName}`} &middot; <span> {dateFormator.timeAgo(review.postedDateTime)}</span></h6> : null}
                            <div className="thumbnail_star">
                                <div className={styles.rating_font}>
                                    <StarRatingComponent
                                        name="star rating"
                                        starColor="#138808"
                                        emptyStarColor="#138808"
                                        value={parseInt(review.rating)}

                                        renderStarIcon={(index, value) => {
                                            return (
                                                <span>
                                                    <i className={index <= value ? 'fas fa-star' : 'far fa-star'} />
                                                </span>
                                            );
                                        }} />
                                </div>
                            </div>
                            <h4>Rating Description</h4>
                        </div>
                        <div className="review_text">{review.description}</div>
                    </div>
                    {this.props.listing.businessPackage === 'premium' || this.props.listing.listingType === 'article' || this.props.listing.listingType === 'news' || this.props.listing.listingType === 'photos' || this.props.listing.listingType === 'reviews' ?
                        <div className="comment-box">
                            <div className="row form-row">
                                <div className="col-md-12">
                                    <button
                                        className="btn btn-link"
                                        style={{ color: review.likes.includes(userId) ? 'green' : '#333333' }}
                                        type="button"
                                        onClick={() => this._likeDislike('liked', review, index)}
                                    ><i className="fa fa-thumbs-up" aria-hidden="true"></i>(<span>
                                            {review.likes.length}
                                        </span>)
                                    </button>

                                    <button
                                        className="btn btn-link button_space"
                                        style={{ color: review.disLikes.includes(userId) ? '#FF9933' : '#333333' }}
                                        type="button"
                                        onClick={() => this._likeDislike('disliked', review, index)}
                                    ><i className="fa fa-thumbs-down" aria-hidden="true"></i>(<span>
                                            {review.disLikes.length}
                                        </span>)
                                    </button>

                                    <button type="button" className="btn btn-link button_space"
                                        onClick={() => this.showComments(review.reviewId)}>
                                        {this._getCommentsTitle(review.numberOfComments)}
                                    </button>
                                    <button type="button" className="btn btn-link button_space"
                                        onClick={() => this.openCommentsForm(review.reviewId)}>
                                        Comment
                                    </button>
                                </div>
                            </div>
                            {this.state.review_id === review.reviewId && this.state.showCommentForm && !this.props.isAdmin ?
                                commentForm : null}
                            {this.state.review_id === review.reviewId && this.state.showComments ?
                                this.renderComments() : null}
                        </div>
                        : null}
                </div> : null
        })

        return (
            <div className="row form-row">
                <div className="form-group col-md-12">
                    {user !== null && user.id !== undefined && !this.props.isAdmin ?
                        <><h2 className={styles.preview_header}>Ratings &amp; Comments</h2>
                            <div className="current_user_review">
                                <div className="thumbnail right-caption span4">
                                    <img className='avatar-shape' src={user.profilePhoto ? process.env.REACT_APP_IMAGES_URL + user.profilePhoto : defaultUserProfile} alt="" />
                                    <div className="caption">
                                        <h2>{user.username} <span className={styles.caption}></span></h2>
                                        <div className="thumbnail_star">
                                            <div className={styles.caption_rating}>
                                                <StarRatingComponent
                                                    name="app6"
                                                    starColor="#138808"
                                                    emptyStarColor="#138808"
                                                    value={parseInt(this.state.rating)}
                                                    onStarClick={this.state.editReview ? this.onStarClick.bind(this) : null}

                                                    renderStarIcon={(index, value) => {
                                                        return (
                                                            <span>
                                                                <i className={index <= value ? 'fas fa-star' : 'far fa-star'} />
                                                            </span>
                                                        );
                                                    }}
                                                    renderStarIconHalf={() => {
                                                        return (
                                                            <span>
                                                                <span className={styles.span_rating}><i className="far fa-star" /></span>
                                                                <span><i className="fas fa-star-half" /></span>
                                                            </span>
                                                        );
                                                    }} />
                                            </div>
                                        </div>
                                        <h4>Rating Description</h4>
                                    </div>

                                    {this.state.currentUserReview && this.state.currentUserReview.open ?
                                        <button type="button" className={`btn btn-link ${styles.edit_btn}`}
                                            onClick={this._editReview}>{this.state.editReview ? 'Cancel' : 'Edit'} </button> : null}

                                    {(this.state.editReview || !this.state.rating) ?
                                        <div>
                                            <textarea className="form-control review_text listing_desc" aria-label="With textarea"
                                                placeholder="Comment"
                                                value={this.state.review}
                                                onChange={(event) => this.setState({ review: event.target.value })}></textarea>
                                            {this.state.posting ? <AnimatedText text={'3_bars'} className={styles.animatedText} />
                                                : <ButtonStyle type="button" className={`btn ${styles.submitBtn}`}
                                                    handleClick={this.submitReview}> {this.state.currentUserReview ? 'Update Commment' : 'Post Comment'}
                                                </ButtonStyle>}
                                        </div>
                                        : <div className="review_text">{this.state.review}</div>}
                                </div>
                                {this.state.currentUserReview && (this.props.listing.businessPackage === 'premium' || this.props.listing.listingType === 'article' || this.props.listing.listingType === 'news' || this.props.listing.listingType === 'photos' || this.props.listing.listingType === 'reviews') ?
                                    <div className="comment-box">
                                        <div className="row form-row">
                                            <div className="col-md-12">
                                                <button
                                                    className="btn btn-link"
                                                    type="button"
                                                    onClick={null}
                                                >
                                                    <i className="fa fa-thumbs-up" aria-hidden="true"></i>
                                                    (<span> {this.state.currentUserReview.likes ? this.state.currentUserReview.likes.length : 0} </span>)
                                                </button>
                                                <button
                                                    className="btn btn-link button_space"
                                                    type="button"
                                                    onClick={null}
                                                >
                                                    <i className="fa fa-thumbs-down" aria-hidden="true"></i>
                                                    (<span> {this.state.currentUserReview.disLikes ? this.state.currentUserReview.disLikes.length : 0} </span>)
                                                </button>

                                                <button type="button" className="btn btn-link button_space"
                                                    onClick={() => this.showComments(this.state.currentUserReview.reviewId)}>
                                                    {this._getCommentsTitle(this.state.currentUserReview.numberOfComments)}
                                                </button>
                                                <button type="button" className="btn btn-link button_space"
                                                    onClick={() => this.openCommentsForm(this.state.currentUserReview.reviewId)}> Comment </button>
                                            </div>
                                        </div>
                                        {this.state.review_id === this.state.currentUserReview.reviewId && this.state.showCommentForm ?
                                            commentForm : null}
                                        {this.state.review_id === this.state.currentUserReview.reviewId && this.state.showComments ?
                                            this.renderComments() : null}
                                    </div> : null}
                            </div>
                        </> : null}
                    <div className="comment_desc">
                        {reviews.length > 0 ? reviews : <p>No Ratings And Comments</p>}
                        {!user || !user.id ?
                            <Link to={'/login/reviews'}><ButtonStyle className={`btn ${styles.submitBtn}`}>Post Comment</ButtonStyle></Link> : null}
                    </div>
                </div>
            </div>
        )
    }
}

export { ReviewsAndComments };